<div *ngIf="Flag==1">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
            Add Configuration
        </span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close"
            style="float: right; cursor: pointer;">close</i>
    </div>
    <div class="row ">
        <div class="col-lg-12">

            <!-- <mat-form-field class="col-lg-4 text-width">
                <input matInput #customerAutoCompleteInput  autocomplete="off" placeholder="Customer" required
                    aria-label="customer" [matAutocomplete]="autoCustomer" [formControl]="customerCtrl">
                <mat-autocomplete #autoCustomer="matAutocomplete"
                    (optionSelected)="customerSelected($event,customerAutoCompleteInput )">
                    <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
                        <span>{{ customer.Title }}</span>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field> -->
            <mat-form-field class="col-lg-4 text-width">
                <mat-label>Customer</mat-label>
                <mat-select [formControl]="customerCtrl" required (selectionChange)="customerSelected($event)">
                    <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer.Id">
                        {{ customer.Title }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="col-lg-4 text-width">
                <input matInput #jobSiteAutoCompleteInput autocomplete="off" placeholder="JobSite" aria-label="jobsite"
                    required [matAutocomplete]="autoJobsite" [formControl]="jobsiteCtrl">
                <!-- [displayWith]="jobsiteDisplayMapper" -->
                <mat-autocomplete #autoJobsite="matAutocomplete"
                    (optionSelected)="jobsiteSelected($event, jobSiteAutoCompleteInput)">
                    <mat-option *ngFor="let jobsite of filteredJobsites | async" [value]="jobsite">
                        <!--<img style="vertical-align:middle;" aria-hidden src="" height="25" />-->
                        <span>{{ jobsite.Title }}</span>
                        <small></small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12">
            <mat-form-field class="col-lg-4 text-width">

                <input matInput (focus)="focus(5)" #makeAutoCompleteInput placeholder="{{ Translate('Make')}}" required
                    aria-label="Make" [matAutocomplete]="autoMake" [formControl]="makeCtrl">

                <mat-autocomplete #autoMake="matAutocomplete"
                    (optionSelected)="makeSelected($event,makeAutoCompleteInput )">
                    <mat-option *ngFor="let make of filteredMakes | async" [value]="make">
                        <span>{{ make.Title }}</span> |
                        <small>{{make.Symbol}}</small>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field class="col-lg-4 text-width">
                <mat-select placeholder="Base Model" name="BaseModel_" [(ngModel)]="selectedBaseModel"
                    #BaseModel_="ngModel" required (selectionChange)="loadUnitNumber()">
                    <!--  -->
                    <mat-option [value]="type.Id" *ngFor="let type of baseModelList">
                        {{type.Title}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field class="col-lg-4 text-width">
                <mat-select placeholder="Unit Number" name="unitNumber_" [(ngModel)]="selectedUnitNumber"
                    #unitNumber_="ngModel">
                    <mat-option [value]="type.UnitNumber" *ngFor="let type of UnitNumberVm">
                        {{type.UnitNumber}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12" style="text-align: end;">
            <button mat-raised-button (click)="resetFields()"> Reset </button>

            <button mat-raised-button color="warn" (click)="SaveForecastConfigurationData()"
                style="margin-left: 20px;margin-right: 20px;">
                Update/Save
            </button>
        </div>
    </div>
</div>


<div *ngIf="Flag==2">
    <div class="ttmodal__header">
        <span class="ttmodal__title">
            Add Component With Component Type
        </span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close"
            style="float: right;cursor: pointer;">close</i>
    </div>
    <mat-form-field class="header-form-full-width text-width">
        <mat-select placeholder="Component Type" name="componentType_" [(ngModel)]="ComponentType"
            #componentType_="ngModel" (selectionChange)="changeComponentType($event)">
            <mat-option [value]="type.Title" *ngFor="let type of componentTypeList">
                {{type.Title}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="header-form-full-width text-width">
        <mat-select placeholder="Component Description" name="componentDecs_" [(ngModel)]="ComponentTypeDesc"
            #componentType_="ngModel">
            <mat-option [value]="type.compartid_auto" *ngFor="let type of ComponentList">
                {{type.ComponentDescription}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <br>
    <mat-form-field class="header-form-full-width text-width"
        *ngIf="componentTypeId==233 && componentTypeId!=230 && componentTypeId!=231 && componentTypeId!=232">
        <mat-select placeholder="Position" name="Positions" [(ngModel)]="Position" #componentType_="ngModel">
            <mat-option [value]="1">
                Rear
            </mat-option>
            <mat-option [value]="2">
                Front
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field class="header-form-full-width text-width"
        *ngIf="componentTypeId!=233 && componentTypeId!=230 && componentTypeId!=231 && componentTypeId!=232">
        <mat-select placeholder="Position" name="Positions" [(ngModel)]="Position" #componentType_="ngModel">
            <mat-option [value]="type" *ngFor="let type of numbers">
                {{type}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <div class="row">
        <div class="col-lg-12" style="text-align: end;">
            <button mat-raised-button> Cancel </button>

            <button mat-raised-button color="warn" style="margin-left: 20px;margin-right: 20px;"
                (click)="SaveComponentType()">
                Add/Update
            </button>
        </div>
    </div>
    <!-- (selectionChange)="changeComponentType($event)" -->
</div>